import React from "react";
import {useSelector} from "react-redux";
import {Card} from "reactstrap";
import ControllerListItem from "./controllerListItem";
import {getSelectedControllerList} from "../../../redux/Selectors/reports.selectors";

const ControllerList = () => {
  const controllerList = useSelector(getSelectedControllerList);

  return (
    <Card
      style={{
        padding: "1rem 0px",
        boxShadow: "0px 3px 6px #00000029",
        position: "relative",
      }}
    >
      <div
        className="roboto-bold"
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          borderBottom: "1px solid #20C1FF",
          margin: "0px 1rem 0.5rem 1rem",
          color: "#303030",
          paddingBottom: "5px",
        }}
      >
        Appliance
      </div>
      {controllerList.map((controller, index) => {
        return (
          <ControllerListItem
            key={controller.mac}
            controller={controller}
            controllerIndex={index}
          />
        );
      })}
    </Card>
  );
};

export default ControllerList;
